import { forwardRef, PropsWithChildren } from "react";
import classNames from "classnames";

export type RoundedCardProps = PropsWithChildren & {
  radiusStyle?: string;
  className?: string;
  id?: string;
  padding?: string;
};

export const RoundedCard = forwardRef<HTMLDivElement, RoundedCardProps>(
  ({ radiusStyle = "rounded-card", children, className, id, padding = "p-5" }: RoundedCardProps, ref) => {
    return (
      <div ref={ref} className={classNames("bg-white", radiusStyle, "shadow-md", padding, className)} data-testid={"roundedCard"} id={id}>
        {children}
      </div>
    );
  }
);
